// extracted by mini-css-extract-plugin
export default {"canvas":"Application-module__canvas___YZSc1"};